import Card from './card'
import { Trophy, Eye, TrendingUp, Target, Clock, BarChart3 } from "lucide-react";

const gains = [
  {
    icon: Trophy,
    title: "Professional Online Presence",
    description: "A professional online presence that earns trust and credibility from your audience.",
  },
  {
    icon: Eye,
    title: "Increased Brand Visibility",
    description: "Increased brand visibility across the right platforms where your customers are.",
  },
  {
    icon: TrendingUp,
    title: "Steady Inflow of Leads",
    description: "Steady inflow of sales, leads and inquiries that keep your business growing.",
  },
  {
    icon: Target,
    title: "Optimized Ad Spend",
    description: "Optimized ad spend that delivers measurable ROI and keeps you profitable.",
  },
  {
    icon: Clock,
    title: "Time Saved",
    description: "Time saved; you focus on running the business, we handle growth.",
  },
  {icon: BarChart3,
    title: "Growth",
description :'Strategies backed by data, built to keep your business growing.'
  }
];

 const GainsSection = () => {
  return (
    <section className="py-14 bg-blue-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 20px 20px, white 2px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>
      
      <div className="mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-2">
            What You Gain
          </h2>
          <p className="text-center text-primary-foreground/90 mb-6 text-lg">
            Real, measurable results that transform your business
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {gains.map((gain, index) => {
              const Icon = gain.icon;
              return (
                <Card 
                  
                  key={index} 
                  className="bg-gradient-to-tr from-[#102347] to-[#3A3C54] max-w-[350px]  rounded-2xl border border-[#545A6A]   p-6  transition-all duration-300 hover:scale-105"
                >
                  <Icon className="h-12 w-12 text-accent mb-4" />
                  <h3 className="font-bold text-xl mb-3 text-white">{gain.title}</h3>
                  <p className="text-primary-foreground/80 leading-relaxed">{gain.description}</p>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
export default GainsSection;